// extracted by mini-css-extract-plugin
export default {"disabled":"ToggleSwitch_disabled__bPsPG","reverseLabel":"ToggleSwitch_reverseLabel__8t64q"};